import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Experiment({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M14 6V10.17C14 10.7 14.21 11.2 14.58 11.58L19.4 16.4C19.775 16.775 19.98 17.28 19.98 17.81V18.98C19.98 20.08 19.08 20.98 17.98 20.98H5.97998C4.86998 20.98 3.97998 20.08 3.97998 18.98V17.8C3.97998 17.27 4.18998 16.76 4.55998 16.38L9.37998 11.55C9.75498 11.175 9.95998 10.66 9.95998 10.13V5.95M14 6C14.55 6 15 5.55 15 5V4C15 3.44 14.55 3 14 3H9.99998C9.43998 3 8.99998 3.448 8.99998 4V5C8.99998 5.55 9.43998 6 9.99998 6H14ZM4.17998 17H19.82M9.81998 11H14.18" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Experiment;